module.exports = __webpack_public_path__ + "img/Micromonas_pusilla.2773e5b4.jpg";